package com.macrofocus.trenddisplay

import com.macrofocus.trenddisplay.timeseriesplot.DefaultTimeSeriesPlotController
import com.macrofocus.trenddisplay.timeseriesplot.DefaultTimeSeriesPlotView
import com.macrofocus.trenddisplay.timeseriesplot.TimeSeriesPlotModel
import react.FC
import react.Props

@JsExport
external interface TimeSeriesPlotProps : Props {
    var model: TimeSeriesPlotModel<Int, String>?
}

@JsExport
val TimeSeriesPlot = FC<TimeSeriesPlotProps> { props ->
//    val view = useMemo(props.model) {
    val view = DefaultTimeSeriesPlotView<Int, String>()
//    view.rendering.value = Rendering.Density
    view.model = props.model
    DefaultTimeSeriesPlotController<Int, String>(view)
//    view
//    }
    view.component.nativeComponent()
}